import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import globalConstant from "../utils/constants";
import { OrderViewPreference } from "../constants/orderView";

export interface IPreference {
  NavBarPreferences: {
    backGroundImage: string;
    backGroundColor: string;
  };
  orderViewPreference: OrderViewPreference;
  setNavBarPreferences: (newNavBarPreferences: any) => void;
  setOrderViewPreference: (view: OrderViewPreference) => void;
}

const usePreferenceStore = create<IPreference>()(
  persist(
    (set, get) => ({
      NavBarPreferences: {
        backGroundImage:
          "linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%)",
        backGroundColor: "#FF9A8B",
      },
      orderViewPreference: 'priority', 
      setNavBarPreferences: (newNavBarPreferences) => {
        set({
          NavBarPreferences: newNavBarPreferences,
        });
      },
      setOrderViewPreference: (view: OrderViewPreference) => {
        set({
          orderViewPreference: view,
        });
      },
    }),
    {
      name: globalConstant.GLOBAL_PREFERENCES,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        NavBarPreferences: state.NavBarPreferences,
      }),
    }
  )
);

export default usePreferenceStore;
